import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => Boolean(s.accessToken));
  const user = useAuthStore((s) => s.user);
  const impersonating = useAuthStore((s) => Boolean(s.impersonation));
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Super admins never use the user app — their world is the /admin portal.
  // While impersonating, the active session IS the target user (whose role is
  // not super_admin), so this bounce naturally doesn't fire.
  if (user?.role === 'super_admin' && !impersonating) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
